module.exports = __webpack_public_path__ + "static/media/Brow03.d9aedf03.jpeg";